import React, { Component } from "react";
import YaystackNavBar from "../yaystackNavBar";
import Category from "./category";

class CategorySelectionList extends Component {
  state = {};
  render() {
    const self = this;
    var categories = this.props.categories.map(function(category) {
      return (
        <Category
          key={category.id}
          link={false}
          category={category}
          allowSelection={true}
          selectCategory={self.props.selectCategory}
        />
      );
    });
    return (
      <div className="categoryFullPage">
        <YaystackNavBar noLogo={true} />
        <label
          className="yaystack_color yaystack_icon top_left cursor_btn"
          onClick={this.props.showAllCategories}
        >
          <ion-icon name="ios-arrow-back" class="ion-icon" />
        </label>
        <div className="allow_scroll page_top_nav">{categories}</div>
      </div>
    );
  }
}

export default CategorySelectionList;



// WEBPACK FOOTER //
// ./src/components/categories/category_selection_list.jsx